import { createRenderBatcher } from './batcher.mjs';
var _createRenderBatcher = /* @__PURE__ */createRenderBatcher(queueMicrotask, false),
  microtask = _createRenderBatcher.schedule,
  cancelMicrotask = _createRenderBatcher.cancel;
export { cancelMicrotask, microtask };